import { render, staticRenderFns } from "./preview-img.vue?vue&type=template&id=64b28886"
import script from "./preview-img.vue?vue&type=script&lang=js"
export * from "./preview-img.vue?vue&type=script&lang=js"
import style0 from "./preview-img.vue?vue&type=style&index=0&id=64b28886&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports